export default "assets/arrow-e5147c68.svg";